<script>
export default {
    name: "RequestItemsIndex",
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:breadcrum>
            <li>Loan Items - Request Items</li>
        </template>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                  <h5 class="text-sm font-bold">Request Items</h5>
              </template>
              <template v-slot:card-body>
                  <div class="w-full flex justify-end p-1">
                      <router-link 
                        class="btn-sm btn-primary text-xs" 
                        :to="{ name: `loan-items.request-items.create`}">
                            <i class="fa fa-plus"></i> Request
                            </router-link>
                  </div>
                  <div class="w-full overflow-auto">
                      <table class="table table-bordered table-hover">
                        <thead class="text-sm bg-indigo-400">
                            <tr>
                                <th class="p-tiny">ID</th>
                                <th class="p-tiny">Date</th>
                                <th class="p-tiny">Item</th>
                                <th class="p-tiny">Description</th>
                                <th class="p-tiny">Qty</th>
                                <th class="p-tiny">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="p-tiny"></td>
                                <td class="p-tiny"></td>
                                <td class="p-tiny"></td>
                                <td class="p-tiny"></td>
                                <td class="p-tiny"></td>
                                <td class="p-tiny"></td>
                            </tr>
                        </tbody>
                      </table>
                  </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>